/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, ReactNode, useState } from 'react';

import { JwtCliengoPayload } from './types';

import { HsmWebsite } from '@/services/hsm-backend/types';

export interface UserContextType {
  /** JwtPayload object*/
  jwtCliengoPayload?: JwtCliengoPayload;
  /** setState for JwtPayload object*/
  setJwtCliengoPayload(jcp: JwtCliengoPayload): void;
  /** List of websites of the logged user */
  websites: HsmWebsite[] | null;
  /** setState for website list*/
  setWebsites(ws: HsmWebsite[] | null): void;
  /** Flag indicating if the user has admin privileges */
  isAdmin: boolean;
  /** setState for admin flag */
  setIsAdmin(isAdmin: boolean): void;
}

/**
 * Context for user information
 * @property jwtCliengoPayload data contained in valid user JWT
 * @property setJwtCliengoPayload: state dipsatcher
 * @property websites: list of websites of the logged user
 * @property setWebsites: state dipsatcher
 */
export const UserContext = createContext<UserContextType>({
  jwtCliengoPayload: undefined,
  setJwtCliengoPayload: () => {},
  websites: null,
  setWebsites: () => {},
  isAdmin: false,
  setIsAdmin: () => {},
});

/**
 * UserProvider Component.
 * Component to provide user information to its children
 * @param props children components
 * @returns UserProvider Component
 */
export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [jwtCliengoPayload, setJwtCliengoPayload] =
    useState<JwtCliengoPayload>();
  const [websites, setWebsites] = useState<HsmWebsite[] | null>(null);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  return (
    <UserContext.Provider
      value={{
        jwtCliengoPayload,
        setJwtCliengoPayload,
        websites,
        setWebsites,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
